// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"540":"7d2c7194","705":"fe7bca8a","961":"ef1352e2","990":"d6c6b34d"}[chunkId] + ".css";
};